module.exports = __webpack_public_path__ + "static/media/logo_ens.dc08082d.png";